export interface StatusRequest {
  isLoading?: boolean;
  isPristine?: boolean;
  hasError?: boolean;

  message?: string;
}

export interface GenericRequest<T> extends StatusRequest {
  data?: T | null;
}

export interface GenericState<T> extends Required<StatusRequest> {
  data: T | null;
}

export const initialStatus: StatusRequest = {
  isPristine: true,
  isLoading: false,
  hasError: false,
};

export const loadingStatus: StatusRequest = {
  isPristine: false,
  isLoading: true,
  hasError: false,
};

export const successStatus: StatusRequest = {
  isPristine: false,
  isLoading: false,
  hasError: false,
};

export const failStatus: StatusRequest = {
  isPristine: false,
  isLoading: false,
  hasError: true,
};
